<template>
  <div id="div_root" class="imageBody">
    <!-- 顶部 标题栏 -->
    <van-nav-bar
      left-arrow
      style="background-color: #393a3f; position: relative"
      @click-left="handelLeftMenuFunc()"
      @click-right="showSerialPannel = !showSerialPannel"
    >
      <template #left>
        <van-icon name="arrow-left" size="18" color="white" />
      </template>
      <template #right>
        <van-icon name="apps-o" size="18" color="white" />
      </template>
      <template #title>
        <span style="color: white">云影像</span>
      </template>
    </van-nav-bar>
    <div
      class="viewportWrapper"
      oncontextmenu="return false"
      unselectable="on"
      onselectstart="return false"
      onmousedown="return false;"
    >
      <!-- Viewport -->
      <div class="viewport" ref="canvas" data-index="0" oncontextmenu="return false"></div>
      <!-- Overlays -->
      <div class="overlay" style="top: 0px; left: 0px">
        <div>检查号:{{ patientInfo.accessionNumber }}</div>
        <div>影像号:{{ patientInfo.patientId }}</div>
        <div>姓名:{{ IsEncryption ? '***' : patientInfo.name }}</div>
        <div>性别:{{ patientInfo.sex }}</div>
        <div>年龄:{{ patientInfo.age }}</div>
      </div>

      <div class="overlay" style="top: 0px; right: 0px">
        <div>医院名称:{{ patientInfo.hosptialName | ellipsis }}</div>
        <div>检查日期:{{ patientInfo.checkDate }}</div>
        <div>检查时间:{{ patientInfo.checkTime }}</div>
      </div>

      <div class="overlay" style="bottom: 0px; left: 0px">
        <!-- <div>图像序号:{{ patientInfo.number }}</div> -->
        <div>图像序号:{{ currentDicomIndex + 1 }}</div>
      </div>

      <div class="overlay" style="bottom: 0px; right: 0px">
        <div>Zoom:{{ patientInfo.zoom }}</div>
        <div>WW/WC:{{ patientInfo.wwc }}</div>
      </div>
    </div>
    <div class="footer_fix">
      <!--翻页 滑动条-->
      <div class="drag">
        <div class="numb_page">{{ currentDicomIndex + 1 }} <span>/</span>{{ imageCount }}</div>
        <div class="drag_min">
          <div class="home_page" @click="firstImage()">
            <img src="../../assets/home_page.png" />
          </div>
          <div class="previous_page" @click="preImage()">
            <img src="../../assets/previous_page.png" />
          </div>
          <div class="drag_article">
            <van-slider
              v-model="slideIndex"
              :min="1"
              :step="1"
              :max="100"
              :bar-height="6"
              class="drag_article_white"
              active-color="gray"
            >
            </van-slider>
          </div>

          <div class="next_page" @click="nextImage()">
            <img src="../../assets/next_page.png" />
          </div>
          <div class="end_page" @click="lastImage()">
            <img src="../../assets/未页.png" />
          </div>
        </div>
      </div>
      <!-- 选项卡 -->
      <div class="tabs">
        <ul>
          <li class="cur">常规<span></span></li>
          <li>测量<span></span></li>
          <li>视图<span></span></li>
          <li>专用</li>
        </ul>
      </div>
      <div class="tabs_con" style="display: block">
        <ul>
          <li>
            <div class="tabs_con_icon" @click="Wwwc()">
              <img src="../../assets/窗宽窗位.png" />
            </div>
            <p>窗宽窗位</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="ZoomTouchPinch()">
              <img src="../../assets/缩放.png" />
            </div>
            <p>缩放</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="Pan()">
              <img src="../../assets/移动.png" />
            </div>
            <p>平移</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Magnify()">
              <img src="../../assets/放大镜.png" />
            </div>
            <p>放大镜</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="Rotation()">
              <img src="../../assets/旋转.png" />
            </div>
            <p>旋转</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="Reset()">
              <img src="../../assets/重置.png" />
            </div>
            <p>重置</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="fourcornerinformation">
              <img src="@/assets/四角信息.png" />
            </div>
            <p>四角信息</p>
          </li>
        </ul>
      </div>
      <div class="tabs_con">
        <ul>
          <li>
            <div class="tabs_con_icon" @click="Probe()">
              <img src="../../assets/点测量.png" />
            </div>
            <p>点测量</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Angle()">
              <img src="../../assets/角度测量.png" />
            </div>
            <p>角度测量</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Length()">
              <img src="../../assets/直线测量.png" />
            </div>
            <p>直线测量</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Rectangle()">
              <img src="../../assets/矩形测量.png" />
            </div>
            <p>矩形测量</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Test()">
              <img src="../../assets/清除标记.png" />
            </div>
            <p>清除标记</p>
          </li>
        </ul>
      </div>
      <div class="tabs_con">
        <ul>
          <li>
            <div class="tabs_con_icon" @click="Rotation()"><img src="../../assets/旋转.png" /></div>
            <p>旋转</p>
          </li>
        </ul>
      </div>
      <div class="tabs_con">
        <ul>
          <li v-show="false">
            <div class="tabs_con_icon" @click="Interpolation()">
              <img src="../../assets/图像增强.png" />
            </div>
            <p>图像增强</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Invert()">
              <img src="../../assets/反色.png" />
            </div>
            <p>反色</p>
          </li>
          <li >
            <div class="tabs_con_icon" @click="Rotate()">
              <img src="../../assets/任意角度旋转.png" />
            </div>
            <p>自由转动</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="HorizontalRotation()">
              <img src="../../assets/水平旋转.png" />
            </div>
            <p>水平旋转</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="VerticalRotation()">
              <img src="../../assets/垂直旋转.png" />
            </div>
            <p>垂直旋转</p>
          </li>
          <li v-show="isShowOpation">
            <div class="tabs_con_icon" @click="ArrowAnnotate()">
              <img src="../../assets/标识.png" />
            </div>
            <p>标识</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Bone()">
              <img src="../../assets/骨窗.png" />
            </div>
            <p>骨窗</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="Brain()">
              <img src="../../assets/脑窗.png" />
            </div>
            <p>脑窗</p>
          </li>

          <li>
            <div class="tabs_con_icon" @click="Lung()">
              <img src="../../assets/肺窗.png" />
            </div>
            <p>肺窗</p>
          </li>
          <li>
            <div class="tabs_con_icon" @click="SoftTissue()">
              <img src="../../assets/软组织窗.png" />
            </div>
            <p>软组织窗</p>
          </li>
        </ul>
      </div>
    </div>
    <div style="width: 100%; height: 161px; z-index: 0"></div>
    <div id="div_menu" class="menu" v-if="showSerialPannel">
      <span></span>
      <ul>
        <li @click="selectSerial(key)" v-for="(item, key) in serialFirstList" :key="key">
          <div class="menu_imge">
            <div
              ref="dicom"
              v-bind:style="{ width: '64px', height: '64px' }"
              data-index="0"
              oncontextmenu="return false"
            ></div>
          </div>
          <div class="menu_text">
            <p>检查号：{{ item.accessionNumber }}</p>
            <p>姓名：{{ IsEncryption ? '***' : item.name }}</p>
            <p>{{ item.imageCount }}张</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
//引入 cornerstone,dicomParser,cornerstoneWADOImageLoader
// import cornerstone from "cornerstone-core"
// import dicomParser from "dicom-parser"
// import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader'
// Cornerstone 工具外部依赖
// import Hammer from "hammerjs";
// import cornerstoneMath from "cornerstone-math"
// import cornerstoneTools from "cornerstone-tools"

import * as cornerstone from '../../../public/static/cornerstone.js'
import * as dicomParser from '../../../public/static/dicomParser.min.js'
//cornerstoneWADOImageLoader 里面会调用 cornerstoneWADOImageLoaderCodecs，cornerstoneWADOImageLoaderWebWorker 里面的引用路径需要处理
import * as cornerstoneWADOImageLoader from '../../../public/static/cornerstoneWADOImageLoader.js'
import * as Hammer from '../../../public/static/hammer.js'
import * as cornerstoneMath from '../../../public/static/cornerstoneMath.js'
import * as cornerstoneTools from '../../../public/static/cornerstoneTools.js'

import $ from 'jquery' //在需要使用的页面中
import { converter } from '@/utils/encodeConverter'
import { isMobile } from '@/utils/common'

import { GetPatientReportImageInfos, AddCloudImageViewRecord } from '@/api/CloudFilmService'
import { GetFileServiceUrl, GetGoBackUrlParms } from '../../utils/cacheUtils'
import { ArrayGroup } from '../../utils/common'
import { DecryptAES } from '../../utils/stringUtils'

// Specify external dependencies
cornerstoneTools.external.Hammer = Hammer
cornerstoneTools.external.cornerstone = cornerstone
cornerstoneTools.external.cornerstoneMath = cornerstoneMath

cornerstoneTools.init({
  /**
   * When cornerstone elements are enabled,
   * should `mouse` input events be listened for?
   */
  mouseEnabled: true,
  /**
   * When cornerstone elements are enabled,
   * should `touch` input events be listened for?
   */
  touchEnabled: true,
  /**
   * A special flag that synchronizes newly enabled cornerstone elements. When
   * enabled, their active tools are set to reflect tools that have been
   * activated with `setToolActive`.
   */
  globalToolSyncEnabled: false,
  /**
   * Most tools have an associated canvas or SVG cursor. Enabling this flag
   * causes the cursor to be shown when the tool is active, bound to left
   * click, and the user is hovering the enabledElement.
   */
  showSVGCursors: false,
})

cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath
//指定要注册加载程序的基石实例
cornerstoneWADOImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.dicomParser = dicomParser
cornerstone.registerImageLoader('http', cornerstoneWADOImageLoader.loadImage)
cornerstone.registerImageLoader('https', cornerstoneWADOImageLoader.loadImage)

export default {
  filters: {
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0, 10) + '...'
      }
      return value
    },
  },
  data() {
    return {
      msg: 'Hello World!',
      IsEncryption: false,
      headTitle: '原始影像',
      isShowTitle: true,
      exampleStudyImageIds: [],
      serialList: [],
      //序列索引
      serialListIndex: 0,
      //图像总数
      imageCount: 0,
      //当前序列
      currentserial: [],
      //序列是否显示
      isSerialListShow: false,
      //序列第一张数据集合,用户显示序列信息
      serialFirstList: [],
      hidden: 'hidden',
      patientInfo: {
        name: '',
        patientId: '',
        accessionNumber: '',
        number: '',
        sex: '',
        age: '',
        checkDate: '',
        checkTime: '',
        hosptialName: '',
        zoom: '',
        wwc: '',
      },
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      headerHeight: 40,
      bottomHeight: 200,
      viewportHeight: '80%',
      rangeColor: 'red',
      //滑动索引
      slideIndex: 1,
      //当前dicom索引
      currentDicomIndex: 0,
      //分页数量
      slideCount: 0,
      //四角信息显示
      isFourcornerinformationShow: true,
      //四角信息图像
      // fourcornerinformationImage: require("@/assets/四角信息.png"),
      //行总数
      viewCount: 1,
      showMenus: false,
      menus: {
        film: '胶片',
        report: '报告',
      },
      //是否手动滑动
      isHandMove: true,
      //是否显示该功能
      isShowOpation: true,
      //当前影像信息
      currentImage: {},
      //当前缩放比
      currentZoom: 0,
      //上次工具名称
      lastToolName: '',
      showSerialPannel: false,
    }
  },
  methods: {
    handelLeftMenuFunc() {
      this.$router.push({ path: '/reportView?' + GetGoBackUrlParms() })
    },
    initCanvasTools() {
      let _self = this
      // let canvas = this.$refs.canvas;
      this.isInitLoad = false

      // 为 canvasStack 找到 imageIds
      let allImageIds = []
      this.exampleStudyImageIds.forEach(function (imageId) {
        let imageUrl = 'wadouri:' + _self.baseUrl + imageId
        allImageIds.push(imageUrl)
      })

      this.Wwwc()
    },
    show() {
      const _this = this
      // 找到要渲染的元素
      let canvas = this.$refs.canvas
      // 在 DOM 中将 canvas 元素注册到 cornerstone
      cornerstone.enable(canvas, { renderer: 'webgl' })

      let imageId =
        'wadouri:' + 'http://192.168.31.21:8020/CT5/1.3.46.670589.33.1.63739642997755002700001.4763559359410191529.dcm'
      //  Load & Display
      cornerstone.loadAndCacheImage(imageId).then(
        function (image) {
          // 设置元素视口
          var viewport = cornerstone.getDefaultViewportForImage(canvas, image)
          // 显示图像
          cornerstone.displayImage(canvas, image, viewport)
          // 激活工具
          _this.initCanvasTools()
        },
        function (err) {
          alert(err)
        }
      )
    },
    // 窗宽窗位
    Wwwc() {
      this.removeOption('Wwwc')
      const WwwcTool = cornerstoneTools.WwwcTool
      cornerstoneTools.addTool(WwwcTool)
      cornerstoneTools.setToolActive('Wwwc', {
        mouseButtonMask: 1,
      })
    },
    //角度测试
    Angle() {
      this.removeOption('Angle')
      const AngleTool = cornerstoneTools.AngleTool
      cornerstoneTools.addTool(AngleTool)
      cornerstoneTools.setToolActive('Angle', {
        mouseButtonMask: 1,
      })
    },
    //拖动 点测试
    DragProbe() {
      this.removeOption('DragProbe')
      const DragProbeTool = cornerstoneTools.DragProbeTool
      cornerstoneTools.addTool(DragProbeTool)
      cornerstoneTools.setToolActive('DragProbe', {
        mouseButtonMask: 1,
      })
    },
    //放大镜
    Magnify() {
      this.removeOption('Magnify')
      const MagnifyTool = cornerstoneTools.MagnifyTool
      cornerstoneTools.addTool(MagnifyTool)
      cornerstoneTools.setToolActive('Magnify', {
        mouseButtonMask: 1,
      })
    },
    //未知
    OrientationMarkers() {
      this.removeOption('OrientationMarkers')
      const OrientationMarkersTool = cornerstoneTools.OrientationMarkersTool
      cornerstoneTools.addTool(OrientationMarkersTool)
      cornerstoneTools.setToolActive('OrientationMarkers', {
        mouseButtonMask: 1,
      })
    },
    //平移
    Pan() {
      this.removeOption('Pan')
      const PanTool = cornerstoneTools.PanTool
      cornerstoneTools.addTool(PanTool)
      cornerstoneTools.setToolActive('Pan', {
        mouseButtonMask: 1,
      })
    },
    //旋转
    Rotate() {
      this.removeOption('Rotate')
      const RotateTool = cornerstoneTools.RotateTool

      cornerstoneTools.addTool(RotateTool)
      cornerstoneTools.setToolActive('Rotate', {
        mouseButtonMask: 1,
      })
    },
    //标尺
    ScaleOverlay() {
      this.removeOption('ScaleOverlay')
      this.isHandMove = false
      const ScaleOverlayTool = cornerstoneTools.ScaleOverlayTool
      cornerstoneTools.addTool(ScaleOverlayTool)
      cornerstoneTools.setToolActive('ScaleOverlay', {
        mouseButtonMask: 1,
      })
    },
    //矩形窗宽窗位
    WWWCRegion() {
      this.removeOption('WwwcRegion')
      const WwwcRegionTool = cornerstoneTools.WwwcRegionTool
      cornerstoneTools.addTool(WwwcRegionTool)
      cornerstoneTools.setToolActive('WwwcRegion', {
        mouseButtonMask: 1,
      })
    },
    //鼠标滑轮放缩
    ZoomMouseWheel() {
      this.removeOption('ZoomMouseWheel')
      const ZoomMouseWheelTool = cornerstoneTools.ZoomMouseWheelTool
      cornerstoneTools.addTool(ZoomMouseWheelTool)
      cornerstoneTools.setToolActive('ZoomMouseWheel', {
        mouseButtonMask: 1,
      })
    },
    //触放缩
    ZoomTouchPinch() {
      this.removeOption('ZoomTouchPinch')
      if (isMobile()) {
        cornerstoneTools.addTool(cornerstoneTools.ZoomTouchPinchTool, {
          // Optional configuration
          configuration: {
            invert: false,
            preventZoomOutsideImage: false,
            minScale: 0.01,
            maxScale: 20.0,
          },
        })
        cornerstoneTools.setToolActive('ZoomTouchPinch', {
          mouseButtonMask: 1,
        })
      } else {
        this.Zoom()
      }
    },
    //缩放
    Zoom() {
      this.removeOption('Zoom')
      // const ZoomTool = cornerstoneTools.ZoomTool;

      cornerstoneTools.addTool(cornerstoneTools.ZoomTool, {
        // Optional configuration
        configuration: {
          invert: false,
          preventZoomOutsideImage: false,
          minScale: this.currentZoom / 10,
          maxScale: 20.0,
        },
      })

      cornerstoneTools.setToolActive('Zoom', {
        mouseButtonMask: 1,
      })
    },
    //箭头 标记
    ArrowAnnotate() {
      this.removeOption('ArrowAnnotate')
      const ArrowAnnotateTool = cornerstoneTools.ArrowAnnotateTool

      cornerstoneTools.addTool(ArrowAnnotateTool)
      cornerstoneTools.setToolActive('ArrowAnnotate', {
        mouseButtonMask: 1,
      })
    },
    //双向标记
    Bidirectional() {
      this.removeOption('Bidirectional')
      const BidirectionalTool = cornerstoneTools.BidirectionalTool
      cornerstoneTools.addTool(BidirectionalTool)
      cornerstoneTools.setToolActive('Bidirectional', {
        mouseButtonMask: 1,
      })
    },
    //直线角度
    CobbAngle() {
      this.removeOption('CobbAngle')
      const CobbAngleTool = cornerstoneTools.CobbAngleTool
      cornerstoneTools.addTool(CobbAngleTool)
      cornerstoneTools.setToolActive('CobbAngle', {
        mouseButtonMask: 1,
      })
    },
    //椭圆
    EllipticalRoi() {
      this.removeOption('EllipticalRoi')
      const EllipticalRoiTool = cornerstoneTools.EllipticalRoiTool

      cornerstoneTools.addTool(EllipticalRoiTool)
      cornerstoneTools.setToolActive('EllipticalRoi', {
        mouseButtonMask: 1,
      })
    },
    //手绘
    FreehandRoi() {
      this.removeOption('FreehandRoi')
      const FreehandRoiTool = cornerstoneTools.FreehandRoiTool

      cornerstoneTools.addTool(FreehandRoiTool)
      cornerstoneTools.setToolActive('FreehandRoi', {
        mouseButtonMask: 1,
      })
    },
    //长度测量
    Length() {
      this.removeOption('Length')
      const LengthTool = cornerstoneTools.LengthTool

      cornerstoneTools.addTool(LengthTool)
      cornerstoneTools.setToolActive('Length', {
        mouseButtonMask: 1,
      })
    },
    //点测量
    Probe() {
      this.removeOption('Probe')
      const ProbeTool = cornerstoneTools.ProbeTool

      cornerstoneTools.addTool(ProbeTool)
      cornerstoneTools.setToolActive('Probe', {
        mouseButtonMask: 1,
      })
    },
    //矩形
    Rectangle() {
      this.removeOption('RectangleRoi')
      const RectangleRoiTool = cornerstoneTools.RectangleRoiTool

      cornerstoneTools.addTool(RectangleRoiTool)
      cornerstoneTools.setToolActive('RectangleRoi', {
        mouseButtonMask: 1,
      })
    },
    //文本标注
    TextMarker() {
      this.removeOption('TextMarker')
      const TextMarkerTool = cornerstoneTools.TextMarkerTool

      const configuration = {
        markers: ['标注5', '标注4', '标注3', '标注2', '标注1'],
        current: '标注5',
        ascending: true,
        loop: true,
      }

      cornerstoneTools.addTool(TextMarkerTool, {
        configuration,
      })
      cornerstoneTools.setToolActive('TextMarker', {
        mouseButtonMask: 1,
      })
    },
    //鼠标滑动
    ScrollMouseWheel(series) {
      var canvasList = []
      let canvass = this.$refs.canvas
      canvasList.push(canvass)

      canvasList.forEach((canvas) => {
        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)
        const scheme = 'wadouri'
        // const baseUrl = vue.prototype.appConfig.DicomUrl;
        var list = []
        list = series
        // if (index == 0) {
        //   list = series.filter(item => item.ImageIndex % 2 != 0);
        // }
        // else {
        //   list = series.filter(item => item.ImageIndex % 2 == 0);
        // }

        //const series = ["image_1.dcm", "image_2.dcm"];
        const imageIds = list.map((seriesImage) => `${scheme}:${seriesImage.ImageRelaFileName}`)

        //获取当前序列
        this.currentserial = imageIds

        this.imageCount = imageIds.length

        //设置显示数量
        this.slideCount = '1/' + this.imageCount

        // // Add our tool, and set it's mode
        // const StackScrollTool = cornerstoneTools.StackScrollTool;

        // //define the stack
        // const stack = {
        //     currentImageIdIndex: 0,
        //     imageIds,
        // };

        // load images and set the stack
        cornerstone.loadImage(imageIds[0]).then((image) => {
          cornerstone.displayImage(canvas, image)
          //  cornerstoneTools.addStackStateManager(canvas, ["stack"]);
          // cornerstoneTools.addToolState(canvas, "stack", stack);

          //重置
          cornerstone.reset(canvas)

          //窗宽窗位
          this.Wwwc()

          this.currentImage = image
          //加载患者信息
          this.setPatientInfo(image)
        })

        //  cornerstoneTools.addTool(StackScrollTool);
        //  cornerstoneTools.setToolActive("StackScroll", { mouseButtonMask: 1 });

        //滑动时，执行事件
        canvas.addEventListener('cornerstoneimagerendered', this.onImageRendered)
      })
    },
    //图像增强
    Interpolation() {
      let canvas = this.$refs.canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.pixelReplication = !viewport.pixelReplication
      cornerstone.setViewport(canvas, viewport)
    },
    //水平旋转
    HorizontalRotation() {
      this.removeOption('HorizontalRotation')
      let canvas = this.$refs.canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.hflip = !viewport.hflip
      cornerstone.setViewport(canvas, viewport)
    },
    //垂直旋转
    VerticalRotation() {
      this.removeOption('VerticalRotation')
      let canvas = this.$refs.canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.vflip = !viewport.vflip
      cornerstone.setViewport(canvas, viewport)
    },
    //旋转
    Rotation() {
      this.removeOption('Rotation')
      let canvas = this.$refs.canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.rotation -= 90
      cornerstone.setViewport(canvas, viewport)
    },
    //反色
    Invert() {
      this.removeOption('Invert')
      let canvas = this.$refs.canvas
      const viewport = cornerstone.getViewport(canvas)
      viewport.invert = !viewport.invert
      cornerstone.setViewport(canvas, viewport)
    },
    //重置
    Reset() {
      this.removeOption('Reset')
      let canvas = this.$refs.canvas
      cornerstone.reset(canvas)

      //Eraser
    },
    //肺窗
    Lung() {
      this.removeOption('Lung')
      let canvas = this.$refs.canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 1600
      viewport.voi.windowCenter = -600
      cornerstone.setViewport(canvas, viewport)
    },
    //骨窗
    Bone() {
      this.removeOption('Bone')
      let canvas = this.$refs.canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 2000
      viewport.voi.windowCenter = 300
      cornerstone.setViewport(canvas, viewport)
    },
    //软组织窗
    SoftTissue() {
      this.removeOption('SoftTissue')
      let canvas = this.$refs.canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 400
      viewport.voi.windowCenter = 20
      cornerstone.setViewport(canvas, viewport)
    },
    //脑窗
    Brain() {
      this.removeOption('Brain')
      let canvas = this.$refs.canvas
      let viewport = cornerstone.getViewport(canvas)
      viewport.voi.windowWidth = 80
      viewport.voi.windowCenter = 32
      cornerstone.setViewport(canvas, viewport)
    },
    Test() {
      const EraserTool = cornerstoneTools.EraserTool
      cornerstoneTools.addTool(EraserTool)
      cornerstoneTools.setToolActive('Eraser', {
        mouseButtonMask: 1,
      })

      // const ProbeTool = cornerstoneTools.ProbeTool;

      // cornerstoneTools.addTool(ProbeTool);
      // cornerstoneTools.setToolActive("Probe", { mouseButtonMask: 1 });
    },
    //四有信息
    fourcornerinformation() {
      if (this.isFourcornerinformationShow) {
        this.fourcornerinformationImage = require('@/assets/四角信息.png')
        $('.overlay').show()
      } else {
        this.fourcornerinformationImage = require('@/assets/四角信息-无.png')
        $('.overlay').hide()
      }
      this.isFourcornerinformationShow = !this.isFourcornerinformationShow
    },
    //获取服务器数据
    getDicomData() {
      var that = this
      GetPatientReportImageInfos({ patientreportID: this.$route.query.reportInfoID }).then(async (resp) => {
        if (resp && resp.Success && resp.Result) {
          let FilmFileList = resp.Result.find((c) => c.Category === 2)
          if (FilmFileList && FilmFileList.Images && FilmFileList.Images.length > 0) {
            AddCloudImageViewRecord({
              CloudImagePatientID: DecryptAES(this.$route.query.CloudImagePatientID),
              IDs: FilmFileList.ExaminationImageIDs,
            }).then()
          }

          let fimeImages = resp.Result.filter((c) => c.Category === 2).map((c) => c.Images)
          if (fimeImages && fimeImages.length > 0) {
            fimeImages = fimeImages[0]
            const fileServiceUrl = await GetFileServiceUrl()
            let NewSerialIndex = 0
            let OldSerialIndex = fimeImages[0].SerialIndex
            fimeImages.forEach((c) => {
              c.ImageRelaFileName = fileServiceUrl + c.ImageRelaFileName
              if (OldSerialIndex !== c.SerialIndex) {
                OldSerialIndex = c.SerialIndex
                NewSerialIndex = NewSerialIndex + 1
              }
              c.SerialIndex = NewSerialIndex
            })
            var imageGroup = ArrayGroup(fimeImages, 'SerialIndex')
            if (imageGroup) {
              this.serialList = []
              imageGroup.forEach((item) => {
                this.serialList[item.key] = item.value
              })
              //滑动翻页
              this.ScrollMouseWheel(this.serialList[0])
              //获取序列第一张图
              this.serialFirstList = []
              this.serialList.forEach((item, serialIndex) => {
                this.getDicomInfo(item, serialIndex)
                that.serialFirstList.push({
                  key: serialIndex,
                  dicom: item[0],
                  imageCount: item.length,
                })
              })
              console.log(this.serialFirstList);

            }
          } else {
            this.$notify({ type: 'warning', message: '没有查询到该检查的原始影像！' })
          }
        }
      })
    },
    //第一张影像
    firstImage() {
      this.currentDicomIndex = 0
      this.imageIndexChange()
    },
    //上一张影像
    preImage() {
      if (this.currentDicomIndex > 0) {
        this.currentDicomIndex -= 1
      }
      this.imageIndexChange()
    },
    //下一张影像
    nextImage() {
      if (this.currentDicomIndex < this.imageCount - 1) {
        this.currentDicomIndex += 1
      }
      this.imageIndexChange()
    },
    //最后一张影像
    lastImage() {
      this.currentDicomIndex = this.imageCount - 1
      this.imageIndexChange()
    },
    //图像序列变化计算 Slider的值 加载图片
    imageIndexChange() {
      if (this.currentDicomIndex < this.imageCount - 1) {
        const slideValue = Math.floor(this.currentDicomIndex * (100 / this.imageCount))
        this.slideIndex = slideValue === 0 ? 1 : slideValue
      } else {
        this.slideIndex = 100
      }
    },
    //显示序列
    showSerial() {
      this.isSerialListShow = true
      this.hidden = ''
      //加载序列列表数据
      this.getSerialList()
      //重置滑动
      this.slideIndex = 1
    },
    //选择序列
    selectSerial(key) {
      //设置序列索引
      this.serialListIndex = key
      this.currentDicomIndex = 0
      this.showSerialPannel = false
      //加载序列列表
      this.ScrollMouseWheel(this.serialList[key])
    },
    //获取序列显示图像信息
    getSerialList() {
      var index = 0
      //生成图像
      this.serialFirstList.forEach((item) => {
        //生成图像
        // 找到要渲染的元素
        const canvas = this.$refs.dicom[index]

        // 在 DOM 中将 canvas 元素注册到 cornerstone
        cornerstone.enable(canvas)

        var dicom = item.dicom
        // let imageId = "wadouri:" + vue.prototype.appConfig.DicomUrl + dicom.ImagePath;
        let imageId = 'wadouri:' + dicom.ImageRelaFileName
        //  Load & Display
        cornerstone.loadAndCacheImage(imageId).then(
          function (image) {
            // 设置元素视口
            var viewport = cornerstone.getDefaultViewportForImage(canvas, image)
            // 显示图像
            cornerstone.displayImage(canvas, image, viewport)
          },
          function (err) {
            alert(err)
          }
        )

        index++
      })
    },
    //设置患者信息
    setPatientInfo(image) {
      //检查号
      this.patientInfo.accessionNumber = image.data.string('x00080050')
      //影像号
      this.patientInfo.patientId = image.data.string('x00100020')

      //姓名
      var code = image.data.string('x00080005')
      // var name = image.data.string("x00100010");

      if (code == 'GB18030') {
        code = 'ISO_IR 100'
      }

      if (code !== undefined) {
        //姓名
        this.patientInfo.name = converter(image.data.string('x00100010'), code, 'gb18030')

        //医院名称
        this.patientInfo.hosptialName = converter(image.data.string('x00080080'), code, 'gb18030')
      } else {
        code = 'ISO_IR 100'
        var encode = 'gb18030' //gbk gb18030;
        this.patientInfo.name = converter(image.data.string('x00100010'), code, encode)

        //医院名称
        this.patientInfo.hosptialName = converter(image.data.string('x00080080'), code, encode)
      }

      //匿名
      // var shareInfo = {} //getShare();
      // var requestParameter = {} //getRequest();

      // if (
      //     shareInfo !== null &&
      //     shareInfo.AnonymousShare &&
      //     requestParameter.Type === 1
      // ) {
      //     this.patientInfo.name = "***";
      // }

      //年龄
      this.patientInfo.age = image.data.string('x00101010')
      //性别
      this.patientInfo.sex = image.data.string('x00100040')
      //医院名称
      //this.patientInfo.hosptialName = image.data.string("x00080080");

      //检查日期
      this.patientInfo.checkDate = this.moment(image.data.string('x00080022')).format('YYYY-MM-DD')
      //检查时间
      const time = image.data.string('x00080030')
      if (time.length >= 6) {
        this.patientInfo.checkTime = time.substring(0, 2) + ':' + time.substring(2, 4) + ':' + time.substring(4, 6)
      }

      //图像序列
      this.patientInfo.number = image.data.string('x00200013')
      //放缩比
      this.patientInfo.zoom = image.data.string('x00100020')

      //第一次加载获取最开始放缩比记录当前值
      this.currentZoom = parseFloat(this.patientInfo.zoom).toFixed(2)
      //窗宽窗位
      this.patientInfo.wwc = image.data.string('x00281051')
    },
    //滑动或者翻页时，执行事件
    onImageRendered(e) {
      const eventData = e.detail
      //图像序列
      this.patientInfo.number = eventData.image.data.string('x00200013')
      //放缩比
      this.patientInfo.zoom = eventData.viewport.scale.toFixed(2)

      //获取当前缩放比
      //this.currentZoom = this.patientInfo.zoom;
      //窗宽窗位
      this.patientInfo.wwc =
        parseInt(eventData.viewport.voi.windowWidth) + '/' + parseInt(eventData.viewport.voi.windowCenter)
    },
    //颜色
    onRangeColor() {
      return '#ffff'
    },
    //加载当前影像
    loadCurrnetDicom(index) {
      let canvas = this.$refs.canvas

      // 在 DOM 中将 canvas 元素注册到 cornerstone
      cornerstone.enable(canvas)
      // const scheme = "wadouri";

      //当前序列名称
      const imageIds = this.currentserial

      //获取当前序列
      this.currentserial = imageIds

      let currentImageId = this.currentserial[index]
      //  this.imageCount = imageIds.length;
      canvas.tabIndex = 0
      canvas.focus()

      // load images and set the stack
      cornerstone.loadAndCacheImage(currentImageId).then((image) => {
        cornerstone.displayImage(canvas, image)
        // cornerstoneTools.addStackStateManager(canvas, ["stack"]);
        //  cornerstoneTools.addToolState(canvas, "stack", stack);

        //设置修改后的缩放比
        // const viewport = cornerstone.getViewport(canvas);
        // viewport.scale = this.currentZoom;
        // cornerstone.setViewport(canvas, viewport);
      })
    },
    //获取dicom信息
    getDicomInfo(item, index) {
      var that = this
      var dicom = item[0]
      // let imageId = "wadouri:" + vue.prototype.appConfig.DicomUrl + dicom.ImagePath;
      let imageId = 'wadouri:' + dicom.ImageRelaFileName
      // load images and set the stack
      cornerstone.loadAndCacheImage(imageId).then((image) => {
        var patientInfo = that.serialFirstList[index]

        //检查号
        patientInfo.accessionNumber = image.data.string('x00080050')
        //影像号
        patientInfo.patientId = image.data.string('x00100020')

        //姓名
        var code = image.data.string('x00080005')

        if (code !== undefined) {
          //姓名
          patientInfo.name = converter(image.data.string('x00100010'), code, 'gb18030')
          //医院名称
          patientInfo.hosptialName = converter(image.data.string('x00080080'), code, 'gb18030')
        } else {
          code = 'ISO_IR 100'
          var encode = 'gb18030' //gbk gb18030;

          //姓名
          patientInfo.name = converter(image.data.string('x00100010'), code, encode)

          //医院名称
          patientInfo.hosptialName = converter(image.data.string('x00080080'), code, encode)
        }

        // //匿名
        // var shareInfo = {} //getShare();
        // var requestParameter = {} //getRequest();

        // if (
        //     shareInfo !== null &&
        //     shareInfo.AnonymousShare &&
        //     requestParameter.Type === 1
        // ) {
        //     patientInfo.name = "***";
        // }

        //年龄
        patientInfo.age = image.data.string('x00101010')
        //性别
        patientInfo.sex = image.data.string('x00100040')

        //检查日期
        patientInfo.checkDate = this.moment(image.data.string('x00080022')).format('YYYY-MM-DD')
      })
              console.log('getDicomInfo',this.serialFirstList);

    },
    //点击事件
    click(key) {
      if (key == 'film') {
        if (isMobile()) {
          this.$router.push('/MobileFilm')
        } else {
          this.$router.push('/MobileFilm')
        }
      } else {
        this.$router.push(key)
      }
    },
    //滑动开始
    ontouchstart() {
      this.isHandMove = false
    },
    //滑动结束
    ontouchend() {
      this.isHandMove = false
    },
    //清除上一次操作，并添加本次操作
    /**
     * @desc 清除上一次的操作
     */
    removeOption(currentName) {
      // if (this.lastToolName !== currentName) {
      //     //清除上一次
      //     cornerstoneTools.removeTool(this.lastToolName);
      //     this.lastToolName = currentName;
      // }
      this.lastToolName = currentName
    },
  },
  created() {},
  activated() {
    this.IsEncryption = DecryptAES(this.$route.query.isEncryption) === '1'
    this.getDicomData()
  },
  mounted() {
    // console.log(document.getElementById('viewport'))
    // this.show();
    /*选项卡*/
    $('.tabs ul li').click(function () {
      $(this).addClass('cur').siblings().removeClass('cur')

      var i = $(this).index()

      $('.tabs_con').eq(i).show().siblings('.tabs_con').hide()
    })
    $('.tabs_con ul li').click(function () {
      var reset = $(this).find('.reset')
      //重置不选中
      if (reset.length == 0) {
        $(this).addClass('cur').siblings().removeClass('cur')
      }
    })

    $('.tabs_con ul li.reset').off('click')

    //窗口变化

    window.onresize = () => {
      return (() => {
        //刷新页面
        location.reload()
        this.Reset()
      })()
    }

    //是否显示功能
    if (isMobile) {
      this.isShowOpation = false
    } else {
      this.isShowOpation = true
    }
  },
  computed: {},
  watch: {
    /* 
                获取索引,向上取整
            */ slideIndex(value) {
      if (value === 1) {
        this.currentDicomIndex = 0
      } else if (value == 100) {
        this.currentDicomIndex = this.imageCount - 1
      } else {
        const _value = Math.ceil((value / 100) * this.imageCount)
        if (_value < this.imageCount) {
          this.currentDicomIndex = _value
        } else {
          this.currentDicomIndex = _value - 1
        }
      }
      //判断是否手滑动翻页
      this.loadCurrnetDicom(this.currentDicomIndex)
    },
    //显示顶部序列菜单
    showSerialPannel(value) {
      if (value) {
        this.$nextTick(() => {
          this.showSerial()
        })
      }
    },
  },
}
</script>

<style scoped>
@charset "utf-8";

body {
  margin: 0 !important;
}

/*影像*/
.imageBody {
  width: 100%;
  height: 100%;
  background-color: #000;
  display: flex;
  flex-direction: column;
}

.image {
  width: 100%;
  position: relative;
  flex: 1;
}

.image_text p {
  height: 22px;
  color: #fff;
  line-height: 22px;
  font-size: 13px;
}

.leftTop {
  position: absolute;
  left: 3px;
  top: 5px;
}

.rightTop {
  position: absolute;
  right: 3px;
  top: 5px;
  text-align: right;
}

.leftBot {
  position: fixed;
  left: 3px;
  bottom: 163px;
}

.rightBot {
  position: fixed;
  right: 3px;
  bottom: 163px;
  text-align: right;
}

.footer_fix {
  width: 100%;
  height: 161px;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
}

.drag {
  padding-bottom: 10px;
  border-bottom: #fff 1px solid;
}

.numb_page {
  width: 100%;
  height: 16px;
  font-size: 15px;
  line-height: 16px;
  text-align: center;
  color: #fff;
}

.drag_min {
  width: 100%;
  height: 30px;
  padding: 0 13px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}

.home_page {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  float: left;
  margin-right: 10px;
}

.previous_page {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  float: left;
}

.drag_article {
  height: 30px;
  float: left;
  position: relative;
  flex: 1;
  margin: 0 20px;
}

.drag_article_blue {
  height: 8px;
  position: absolute;
  left: 0;
  top: 11px;
  border-radius: 8px;
  background: #fff;
  z-index: 99;
  position: relative;
}

.drag_article_blue:after {
  content: '';
  display: block;
  position: absolute;
  top: -7px;
  right: -10px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #fff;
  z-index: 100;
}

.drag_article_white {
  width: 100%;
  height: 8px;
  position: absolute;
  left: 0;
  top: 12px;
  border-radius: 8px;
  z-index: 80;
  margin-left: 0px;
  margin-right: 0px;
}

.next_page {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  float: right;
  margin-right: 10px;
}

.end_page {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  float: right;
}

/*选项卡*/
.tabs {
  width: 100%;
  height: 38px;
  background: #000;
  border-top: #747474 1px solid;
  cursor: pointer;
}

.tabs ul li {
  font-size: 14px;
  color: #fff;
  line-height: 22px;
  width: 25%;
  margin: 8px 0;
  text-align: center;
  float: left;
  position: relative;
}

.tabs ul li:last-child {
  border-right: none;
}

.tabs ul li.cur {
  background: #393a3f;
  font-weight: 900;
  line-height: 37px;
  margin: 0;
  border-right: #747474 1px solid;
  border-left: #747474 1px solid;
  margin-left: -1px;
}

.tabs ul li span {
  text-align: right;
  border-right: 1px solid #747474;
  height: 22px;
  width: 1px;
  position: absolute;
  right: 0px;
  top: 0px;
}

.tabs ul li.cur span {
  display: none;
}

.tabs ul li:last-child.cur {
  margin-right: 1px;
  border-right: none;
}

.tabs_con {
  height: 65px;
  display: none;
}

.tabs_con ul {
  width: 100%;
  height: 65px;
  overflow-x: auto;
  white-space: nowrap;
  overflow-y: hidden;
}

.tabs_con ul li {
  width: 65px;
  height: 55px;
  margin: 3px 5px 5px;
  border-radius: 4px;
  display: inline-block;
}

.tabs_con ul li.cur {
  background: #393a3f;
}

.tabs_con ul li:first-child {
  margin-left: 10px;
}

.tabs_con ul li .tabs_con_icon {
  width: 35px;
  height: 35px;
  margin: 0 15px;
  cursor: pointer;
}

.tabs_con ul li p {
  font-size: 13px;
  color: #fff;
  line-height: 14px;
  text-align: center;
}

.menu {
  width: 75%;
  background: #fff;
  border-radius: 5px;
  padding: 0 12px;
  position: fixed;
  right: 5px;
  top: 56px;
  z-index: 9999;
  max-height: 50%;
  overflow-y: scroll;
}

.menu span {
  width: 0;
  height: 0;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
  position: fixed;
  top: 40px;
  right: 20px;
}

.menu ul li {
  margin: 12px auto 0px;
  overflow: hidden;
  border-bottom: #e9e9e9 1px solid;
  padding-bottom: 12px;
  display: flex;
}

.menu ul li .menu_imge {
  width: 64px;
  height: 64px;
  margin-right: 12px;
}

.menu ul li .menu_text {
  flex: 1;
}

.menu ul li .menu_text p {
  font-size: 14px;
  color: #333;
  line-height: 22px;
}

.image-canvas-wrapper {
  width: 100%;
  height: 80vh;
  margin: 0 auto;
}

.image-canvas {
  width: 512px;
  height: 512px;
}

/*第三方*/
/* prevent 'bounce' in scrolling */
html {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

body {
  height: 100%;
  width: 100%;
  overflow: auto;
  color: #888888;
  background-color: #060606;
}

.hidden {
  display: none;
}

.modal-content {
  background-color: #202020;
}

.btn-default {
  color: #ffffff;
  background-color: #424242;
  border-color: #424242;
}

/* images are displayed in viewports */
.viewport {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  position: relative;
}

.overlay {
  position: absolute;
  color: #ffffff;
  font-size: 14px;
}

.myNav {
  margin: 0;
  border: 0;
}

.viewportWrapper {
  box-sizing: border-box;
  border: 2px solid #777;
  flex: 1;
  width: 99.5%;
  position: relative;
  color: white;
  float: left;
  top: 0px;
  background: black;
}

.csthumbnail {
  color: white;
  background-color: black;
  width: 100px;
  height: 100px;
  border: 0px;
  padding: 0px;
}

.viewer {
  /*position: absolute;left: 110px;width: 100%;*/
  float: left;
  box-sizing: border-box;
}

.thumbnailSelector {
  width: 106px;
  float: left;
  margin-left: 0px;
  height: 100%;
}

body,
html {
  height: 100%;
}

#wrap {
  height: 100%;
}

.studyContainer {
  margin-top: 2px;
  margin-left: 0px;
  margin-right: 0px;
  padding: 0px;
}

.navbar-default {
  background-color: #060606;
  border-color: #000000;
}

.thumbnails {
  margin: 0px;
  margin-bottom: 0px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.table {
  border-collapse: collapse;
  border-color: gray;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 4px;
  border: 1px solid #282828;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #202020;
}

.studyRow {
  margin-left: 0px;
  margin-right: 0px;
  height: 100%;
}

.row {
  margin: 0;
}

a.list-group-item {
  background-color: black;
  padding: 2px;
  border: 1px solid #424242;
  z-index: 5;
}

a.list-group-item.active,
a.list-group-item.active:hover,
a.list-group-item.active:focus {
  background-color: #424242;
  border-color: #4e4e4e;
}

.nav-tabs {
  border-bottom: 1px solid #424242;
}

.nav-tabs > li > a {
  background-color: #202020;
  border-color: #424242;
  color: #424242;
  padding: 3px 10px;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background-color: #424242;
  border-color: #424242;
  color: #ffffff;
  padding: 3px 10px;
}

.dropdown-menu {
  min-width: 40px;
}

.weui-grids {
  background-color: red;
  height: 100%;
}

.weui-grid {
  height: 100%;
  background-color: red;
  padding: 0;
}

.weui-grids a:active {
  color: red;
}
</style>